<label>{{ 'FormulationSearch.Label.ColorGroup' | translate }}</label>
<ng-select [(ngModel)]="value" [keyDownFn]="selectOnTab" [items]="colorCategories" bindLabel="name"
    name="color-category-select" [ngClass]="{'ng-field-selected': isFilled}">
</ng-select>
